import { DictionaryKey } from "./dictionaries";
import { Filter } from "./generalSearchFilter";
import {
  Transform,
  ParallelTransform,
  ConditionalTransform,
} from "./generalSearchTransform";

export type GeneralSearchQuery =
  | Filter
  | Transform
  | ParallelTransform
  | ConditionalTransform
  | Empty
  | RegexReplaceSearch
  | Sequence
  | TraceGroupingQuery;

export type QueryBase = {
  enabled?: boolean;
  comment?: string;
};

export type Empty = QueryBase & {
  type: "";
};

export type DictionaryOrEmpty = "" | DictionaryKey;

export interface RegexReplaceBase {
  enabled?: boolean;
  comment?: string;
  pattern: string;
  replacement: string;
}

export type RegexReplaceSearch = RegexReplaceBase & {
  type: "regexReplaceSearch";
  dictionary: DictionaryOrEmpty;
  anagramMatch: boolean;
  matchOnly: true;
};

export type Sequence = QueryBase & {
  type: "sequence";
  sequenceType: string;
  option?: any;
  processes: GeneralSearchQuery[];
};

export type TraceGroupingQuery = QueryBase & {
  type: "traceGrouping";
  groupKey: string;
  groupValue: string;
  enableTrace: number[];
};

export const listPlaceholderCharacter = "#";
export const listTerminateCharacter = ";";
